import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Auth} from '../../auth/auth.service';
import {MessengerService} from '../../messenger/messenger.service';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';
import {Series} from '../classes/series';

@Component({
    selector: 'kkk-series',
    templateUrl: './series.component.html',
    styleUrls: ['./series.component.scss']
})
export class SeriesComponent implements OnInit {

    public series: Series[];

    constructor(
        public auth: Auth,
        private route: ActivatedRoute,
        private router: Router,
        private _breadcrumbs: BreadcrumbsService,
        private _messenger: MessengerService,
    ) {
    }

    ngOnInit() {
        this._breadcrumbs.start({name: 'Felvételek', instructions: ['/felvetelek']}).add({name: 'Sorozatok'});
        new Series().all().subscribe(
            series => this.series = series,
            e => {
                this._messenger.handleError(e);
                this.series = [];
            }
        );
    }

    loadLectures(series: Series) {
        series.storeForNext();
        return this.router.navigate([series.id], {relativeTo: this.route});
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/sermons/series/series.component.ts